export var PatternOrientation = {
  horizontal: 'horizontal',
  vertical: 'vertical',
  diagonal: 'diagonal',
  diagonalRightToLeft: 'diagonalRightToLeft'
};